var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto w-75 text-center",staticStyle:{"padding-top":"3rem"}},[_vm._v(" 存在しないURLです ")])}
var staticRenderFns = []

export { render, staticRenderFns }